'use strict';

customerZone.controller('MySettingsController', ['$log', 'utils', 'Session', 'UnleashedClient', 'errorCode',
    'ControllerBase', function($log, utils, session, api, errorCode, ControllerBase) {

        var self = this;
        ControllerBase.call(this, utils);

        if (session.subscriber())
            self.paymentType =  session.subscriber().isPostpaid() ? 'postpaid' : 'prepaid';

        // handling errors only known after a request has been made
        self.uwaValidationErrors = {};

        /* Password update */

        self.passwords = {};

        self.contactData = {};

        /**
         * Update the password and reset the given form when successful
         */
        self.updatePassword = function($form){
            var updatePasswordPromise = api.changePassword(self.passwords.old_pwd, self.passwords.new_pwd)
                .then(function(){
                    self.passwords = {};
                    $form.$setPristine();
                    $form.$setUntouched();
                })
                .catch(function(error){
                    if (self.handleValidationErrors(error, [
                        {code: errorCode.PASSWORD_TOO_COMMON, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_common'},
                        {code: errorCode.PASSWORD_ENTIRELY_NUMERIC, field: 'newPassword', on: 'newPassword',
                            message: 'password_entirely_numeric_error_message'},
                        {code: errorCode.PASSWORD_TOO_SIMILAR, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_error_message'},
                        {code: errorCode.PASSWORD_SIMILAR_TO_DETAILS, field: 'newPassword', on: 'newPassword',
                            message: 'password_too_similar_to_details_error_message'},
                        {code: errorCode.INVALID_VALUE, field: 'oldPassword', on: 'oldPassword',
                            message: 'incorrect_password'}
                    ], busy)) {
                        $form.$setUntouched();
                    }

                    if (errorCode.on(error, 'newPassword')) self.passwords['new_pwd'] = '';
                    if (errorCode.on(error, 'oldPassword')) self.passwords['old_pwd'] = '';

                    throw error;
                });
            var busy = utils.showBusy(updatePasswordPromise, 'update_password', 'update_password_complete');
            return busy.wrappedPromise;
        };

        /* Contact settings */

        self.getContactData = function(){
            self.loading = utils.translate('loading_data');
            api.getCustomer()
                .then(function (response) {
                    self.contactData = response;
                    self.loading = false;
                })
                .catch(function(){
                    self.loading = false;
                    utils.showError();
                });
        };

        self.updateContactData = function(){
            self.uwaValidationErrors = {};
            var updateCustomerPromise = api.updateCustomer(self.contactData)
                .catch(function(error){
                    self.handleValidationErrors(error, [
                        {code: errorCode.EMAIL_ADDRESS_ALREADY_IN_USE, on: 'email', message: 'email_already_used'},
                        {code: errorCode.INVALID_VALUE, field: 'email', on: 'email', message: 'email_invalid'}
                    ], busy);
                    throw error;
                });
            var busy = utils.showBusy(updateCustomerPromise, 'updating_contact_data', 'contact_data_updated');
            return busy.wrappedPromise;
        };

    }]);
